import { useState, useCallback } from "react";

const STORAGE_KEY = "debugSettings";

export const DEBUG_DEFAULTS = {
  enabled: false,
};

export const DEBUG_SYNC_FIELDS = ["enabled"];

export function getDebugSettings() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (raw) {
      return {
        ...DEBUG_DEFAULTS,
        ...JSON.parse(raw),
      };
    }
  } catch {
    // corrupted data — fall back to defaults
  }

  return { ...DEBUG_DEFAULTS };
}

function saveDebugSettings(settings) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(settings));
  } catch {
    // localStorage full or unavailable — fail silently
  }
}

export function mergeDebugSettingsFromServer(serverSettings) {
  const current = getDebugSettings();
  if (!serverSettings) return current;

  const merged = { ...current };
  const serverDebugSettings = serverSettings.debug_settings;

  if (
    serverDebugSettings &&
    typeof serverDebugSettings === "object" &&
    serverDebugSettings.enabled !== undefined
  ) {
    merged.enabled = Boolean(serverDebugSettings.enabled);
  }

  saveDebugSettings(merged);
  return merged;
}

export function debugSettingsToApi(settings) {
  return {
    debug_settings: {
      enabled: Boolean(settings.enabled),
    },
  };
}

const useDebugSettings = ({ onSync } = {}) => {
  const [settings, setSettings] = useState(getDebugSettings);

  const updateSettings = useCallback(
    (partial) => {
      setSettings((prev) => {
        const next = {
          ...prev,
          ...partial,
        };
        saveDebugSettings(next);
        onSync?.(debugSettingsToApi(next));
        return next;
      });
    },
    [onSync],
  );

  return [settings, updateSettings];
};

export default useDebugSettings;
